var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgTag = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.5247 5.59538C20.4907 4.5414 19.6442 3.6949 18.5903 3.6609L11.7402 3.43993C11.1876 3.4221 10.6524 3.63377 10.2615 4.02467L2.52446 11.7617C1.74341 12.5427 1.74341 13.8091 2.52446 14.5901L9.59553 21.6612C10.3766 22.4422 11.6429 22.4422 12.424 21.6612L20.161 13.9242C20.5519 13.5333 20.7635 12.998 20.7457 12.4455L20.5247 5.59538ZM18.5258 5.65986L18.7467 12.51L11.0097 20.247L3.93867 13.1759L11.6757 5.43889L18.5258 5.65986ZM12.424 11.7617C13.205 12.5427 14.4713 12.5427 15.2524 11.7617C16.0334 10.9806 16.0334 9.71429 15.2524 8.93325C14.4713 8.1522 13.205 8.1522 12.424 8.93325C11.6429 9.7143 11.6429 10.9806 12.424 11.7617Z",
    fill: "#071A24",
    fillOpacity: 0.25
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgTag);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/tag.7c555c57b8688903964038d1fdfc8ede.svg";